import React from 'react';
import { errorStyles, styles } from './CustomSelect.sx';
import Select from 'react-select/creatable';
import { components } from 'react-select';
import { Controller } from 'react-hook-form';
import { Box } from '@mui/material';
import FieldError from 'app/components/FieldError';
import logger from 'app/utils/logger';

interface Props {
  value?: any;
  error?: any;
  onChange?: any;
  options?: any;
  control?: any;
  rest?: any;
  label: string;
  isMulti?: boolean;
  disabled?: boolean;
}

const MoreSelectedBadge = ({ items }: any) => {
  const style = {
    marginLeft: 'auto',
    background: '#d4eefa',
    borderRadius: '4px',
    fontSize: '11px',
    padding: '3px',
    order: 99,
  };

  const title = items.join(', ');
  const length = items.length;
  const label = `+ ${length} item${length !== 1 ? 's' : ''} selected`;

  return (
    <div style={style} title={title}>
      {label}
    </div>
  );
};

const MultiValue = ({ index, getValue, ...props }: any) => {
  const maxToShow = 3;
  const overflow = getValue()
    .slice(maxToShow)
    .map((x: any) => x.label);

  return index < maxToShow ? (
    <components.MultiValue {...props} />
  ) : index === maxToShow ? (
    <MoreSelectedBadge items={overflow} />
  ) : null;
};

const CustomValueContainer = ({ children, ...props }: any) => {
  return (
    <components.ValueContainer {...props}>
      <components.Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </components.Placeholder>
      {children.map((child: any) => (child && child.key !== 'placeholder' ? child : null))}
    </components.ValueContainer>
  );
};

const CreatableSelect = (props: Props) => {
  const { options, control, rest, label, error, isMulti, disabled } = props;

  return (
    <Box sx={{ height: '69px', width: '100%' }}>
      {control !== undefined && (
        <Controller
          control={control}
          render={({ field: { onChange: onChangeInput, ref, value } }) => (
            <Select
              ref={ref}
              placeholder={label}
              styles={error !== undefined ? errorStyles : styles}
              isDisabled={disabled}
              components={{
                IndicatorSeparator: () => null,
                ValueContainer: CustomValueContainer,
                MultiValue,
              }}
              value={value}
              options={options}
              onChange={(selectedValue: any) => {
                onChangeInput(selectedValue);
              }}
              isMulti={isMulti}
              isClearable={false}
              isSearchable={true}
              hideSelectedOptions={false}
            />
          )}
          name={rest.name}
        />
      )}
      <FieldError error={error} />
    </Box>
  );
};
export default CreatableSelect;
